module.exports = __webpack_public_path__ + "img/date.0ff9ee20.svg";